import type { ImgHTMLAttributes } from "react";

import PropertyCard from "@/components/property-card";
import type { Property } from "@shared/schema";

export type PropertyListProps = {
  properties: Property[];
  selectedId?: string | null;
  onSelect?: (property: Property) => void;
  onScheduleTour?: (property: Property) => void;
  onContactAgent?: (property: Property) => void;
  onHoverCard?: (propertyId: string) => void;
  cardIdPrefix?: string;
  cardImageProps?: ImgHTMLAttributes<HTMLImageElement>;
};

export default function PropertyList({
  properties,
  selectedId,
  onSelect,
  onScheduleTour,
  onContactAgent,
  onHoverCard,
  cardIdPrefix,
  cardImageProps,
}: PropertyListProps) {
  if (!properties.length) {
    return (
      <div className="py-14 text-center text-sm text-slate-400">
        No properties match the current map bounds.
      </div>
    );
  }

  return (
    <div className="space-y-5 pb-16">
      {properties.map((property) => {
        const isSelected = selectedId === property.id;

        return (
          <div
            key={property.id}
            className={`transition-all duration-200 rounded-3xl overflow-hidden ${
              isSelected ? "ring-2 ring-blue-500/80" : "ring-1 ring-transparent"
            }`}
          >
            <PropertyCard
              property={property}
              onScheduleTour={() => onScheduleTour?.(property)}
              onContactAgent={() => onContactAgent?.(property)}
              onClick={() => onSelect?.(property)}
              onHover={onHoverCard}
              idPrefix={cardIdPrefix}
              imgProps={cardImageProps}
            />
          </div>
        );
      })}
    </div>
  );
}
